import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import User from '../../models/User';

export interface UserState {
  value: User | null;
}

const initialState: UserState = { value: null };

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state: UserState, action: PayloadAction<User>) => {
      state.value = action.payload;
    },
    resetUser: (state: UserState) => {
      state.value = null;
    },
  },
});

export const selectUser = (state: RootState) => state.user.value;

export const { setUser, resetUser } = userSlice.actions;

export default userSlice.reducer;
